import './Topbar.scss'
import { FaPhone } from 'react-icons/fa'
import { FiMail } from 'react-icons/fi'
import { RiFacebookCircleLine } from 'react-icons/ri'

const Topbar = ({ menuOpen, setMenuOpen }) => {
  return (
    <div className={'topbar ' + (menuOpen && 'active')}>
      <div className='wrapper'>
        <div className='left'>
          <a href='#intro' className='logo-container'>
            <img src='./assets/logo.png' alt='logo' className='logo' />
          </a>
          <div className='itemContainer'>
            <FaPhone className='icon' />
            <span>+8801625558899</span>
          </div>
          <div className='itemContainer'>
            <FiMail className='icon' />
            <span>riyad_ibit@yahoo.com</span>
          </div>
          <div className='itemContainer'>
            <a style={{textDecoration: 'none', color: 'inherit' }} href='https://www.facebook.com/profile.php?id=100063675183591'>
            <RiFacebookCircleLine className='icon' />
            <span>MD Asaduzzaman Riyad</span>
            </a>
            
          </div>
        </div>
        <div className='right'>
          <div className='hamburger' onClick={()=>setMenuOpen(!menuOpen)}>
            <span className='line1'></span>
            <span className='line2'></span>
            <span className='line3'></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Topbar
